import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { Overline, PrimaryButton, SecondaryButton } from "@/components/Primitives";
import { SITE } from "@/data/config";

// Reserved future-ready routes: /client-portal, /login, /account, /dashboard, /admin
// DEV NOTE: These render an informational stub. Do NOT expose any data, forms, or
// admin functions here without secure authentication, DB models, and role-based
// access. Build the secure auth integration first, then replace these stubs.
const Reserved = () => {
  const location = useLocation();
  const path = location.pathname.replace(/^\//, "");
  useSeo({ title: `Future-ready | Kostaja`, description: "Reserved route. Public site only in v1." });

  // Explicit noindex + nofollow so search engines never pick up stub routes.
  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      document.head.appendChild(tag);
    }
    const previous = tag.getAttribute("content");
    tag.setAttribute("content", "noindex,nofollow");
    return () => {
      if (previous) tag.setAttribute("content", previous);
      else tag.remove();
    };
  }, []);

  return (
    <main data-testid={`reserved-${path}`} className="bg-black text-white min-h-[70vh]">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 py-20 lg:py-28 text-center">
        <Overline color="yellow" className="mb-4">Reserved · Future-ready</Overline>
        <h1 className="text-5xl lg:text-7xl font-black tracking-tighter leading-[0.95]">
          This area is being designed for a future client portal and admin.
        </h1>
        <p className="mt-5 text-white/70 text-base lg:text-lg">
          The public Kostaja site is live. Customer portal and admin features will arrive once secure authentication, role-based access, and a private data model are in place.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <PrimaryButton to="/" testId="reserved-home">Back to Home</PrimaryButton>
          <SecondaryButton dark to="/contact" testId="reserved-contact">Talk to the studio</SecondaryButton>
          <a
            href={SITE.bookingUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center font-semibold px-7 py-4 border-2 text-sm tracking-wide border-white text-white hover:border-[#FFC600] hover:text-[#FFC600] transition-colors"
          >
            Start a Project
          </a>
        </div>
      </div>
    </main>
  );
};

export default Reserved;
